import React from "react";
import { Label } from "reactstrap";
import isNoSignature from "../../files/ic_no_signature.svg";
import { deviceType } from "../../constants/general.constant.js";
import getDeviceType from "../../helpers/getDeviceTypeHelper.js";

const SignatureWithName = (props) => {
  const signature = props.signature;
  const name = props.name;
  const isBorder = props.isBorder;
  const style = props.style || {};
  const layoutStyle = props.layoutStyle || {};

  let classes = "col-md-4 div-remove-padding";
  const device = getDeviceType();
  if(device === deviceType.tablet){
    classes = "col-md-12 div-remove-padding";
  }
  return (
    <div className={props.isCCMQuestion ? classes : ""}>
      {isBorder && (
        <>
          <div className="signature-layout remove-margin-right" style={layoutStyle}>
            {/* <p className="signature-title">Signature : </p> */}
            <div>
              {signature && (
                <>
                  <div className="signature-display-image-layout" style={style}>
                    <img
                      src={signature}
                      className="signature-display-image"
                    />
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
              {!signature && (
                <>
                  <div className="signature-display-image-layout-no-signature" style={style}>
                    <img className="no-signature"
                      src={isNoSignature}
                    />
                    <Label className="no-signature-found">
                      Signature could not be found!
                    </Label>
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      {!isBorder && (
        <>
          <div className="signature-layout remove-margin-right">            
            <div>
              {signature && (
                <>
                  <div className="signature-without-border">
                    <img
                      src={signature}
                      className="signature-display-image"
                    />
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
              {!signature && (
                <>
                  <div className="signature-without-border">
                    <img className="no-signature"
                      src={isNoSignature}
                    />
                    <Label className="no-signature-found">
                      Signature could not be found!
                    </Label>
                    <code>
                      <hr className="border-signature" />
                      <p className="signature-label"><i className="mdi mdi-account-circle signature-user-icon" />{name}</p>
                    </code>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignatureWithName;
